/* global Vue */
import SearchCondition from './SearchCondition'
import { safeJsonParse, safeJsonArrayParse } from './utils'

export default function (selector) {
	const container = document.querySelector(selector)
	if (!container) return

	const valueInput = container.querySelector('input')
	if (!valueInput) return

	const app = new Vue({
		el: container,
		components: {
			SearchCondition
		},
		data () {
			return {
				props: {
					value: safeJsonParse(valueInput.value || '', {}),
					leaseTimeClasses: safeJsonArrayParse(container.getAttribute('data-lease-time-classes')),
					carTypes: safeJsonArrayParse(container.getAttribute('data-car-types'))
				}
			}
		},
		template: '<SearchCondition v-bind="props" />'
	})
	return app
}
